export enum FontSize {
  font10 = 10,
  font12 = 12,
  font14 = 14,
  font16 = 16,
}
